<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.75875 11.4972C8.77242 11.9842 8.97151 12.4128 9.35603 12.7831L31.0702 33.6931C31.4547 34.0634 31.8998 34.2551 32.4055 34.2682C32.9129 34.2814 33.3487 34.1126 33.713 33.7619C34.0773 33.4111 34.2526 32.9913 34.2389 32.5027C34.2252 32.0158 34.0261 31.5872 33.6416 31.2169L11.9274 10.3069C11.5429 9.93659 11.0978 9.74487 10.5922 9.73171C10.0847 9.71851 9.64889 9.8873 9.28461 10.2381C8.92032 10.5889 8.74504 11.0086 8.75875 11.4972Z"
      fill="currentColor"
    />
    <path
      d="M10.5933 34.2679C11.0989 34.2547 11.544 34.063 11.9285 33.6927L33.6427 12.7827C34.0272 12.4125 34.2263 11.9838 34.24 11.4969C34.2537 11.0083 34.0784 10.5886 33.7141 10.2378C33.3498 9.88698 32.914 9.71818 32.4066 9.73139C31.9009 9.74455 31.4558 9.93627 31.0713 10.3066L9.35713 31.2166C8.97261 31.5868 8.77352 32.0155 8.75985 32.5024C8.74614 32.991 8.92142 33.4107 9.28571 33.7615C9.64999 34.1123 10.0858 34.2811 10.5933 34.2679Z"
      fill="currentColor"
    />
  </svg>
</template>
